import { Button, Flex, SparkleIcon, Typography } from '@iheartjane/reefer';

import styles from './wizardBanner.module.css';

interface WizardBannerProps {
  label?: string;
  onClickStart: () => void;
}

export const WizardBanner = ({
  label = 'Help me choose',
  onClickStart,
}: WizardBannerProps) => {
  return (
    <Flex
      background="grays-ultralight"
      border="transparent-black-ten"
      borderRadius="sm"
      data-testid="wizard-banner"
      gap={16}
      p={24}
    >
      <SparkleIcon color="primary" />

      <Flex
        alignItems="center"
        className={styles['textAndButton']}
        justifyContent="space-between"
        width="100%"
      >
        <Flex flexDirection="column">
          <Typography
            className={styles['headerText']}
            variant="header-bold"
            color="text-main"
            as="p"
          >
            Need a little guidance? We&rsquo;ll help you find the right fit.
          </Typography>
          <Typography variant="body" color="text-main" as="p">
            Answer 5 quick questions for tailored picks&mdash;plus extra
            personalization when you&rsquo;re signed in.
          </Typography>
        </Flex>

        <Button
          className={styles['cta']}
          label={label}
          onClick={onClickStart}
        />
      </Flex>
    </Flex>
  );
};
